module.exports = __webpack_public_path__ + "img/step_of_death.22eb7afd.svg";